<template>
  <div class="news-list" @click="handleView">
    <div class="item-l">
      <van-image :src="listData.coverImagesList.length?listData.coverImagesList[0].url:''" />
    </div>
    <div class="item-r">
      <p class="item-des">{{ listData.title }}</p>
      <div class="item-bt">
        <van-image :src="listData.articleOriginLogo" />
        {{listData.articleOriginName}}
      </div>
    </div>
  </div>
</template>
<script>
import { Image as VanImage, Icon } from "vant";
import { openArticle } from "@/utils/appMethods.js";
import { getTimer, format } from "@/utils/timer.js";
export default {
  components: {
    VanImage,
    [Icon.name]: Icon,
  },
  props: {
    listData: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    handleView(){
      this.$emit("toApp")
    }
  }
   
};
</script>
<style lang="less">
.news-list {
  height: 188px;
  margin-top: 20px;
  .item-l {
    width: 336px;
    float: left;
    img {
      width: 336px !important;
      height: 188px;
      border-radius: 8px;
    }
  }
  .item-r {
    width: 330px;
    height: 188px;
    float: right;
    font-size: 28px;
    position: relative;
    .item-des {
      margin: 0;
      font-family: PingFang SC;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3; //设置行数
      -webkit-box-orient: vertical;
    }
    .item-bt {
      width: 100%;
      font-size: 24px;
      color: #999;
      position: absolute;
      bottom: 0;
      display: flex;
      align-items: center;
      img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
      }
      
    }

  
  }
}
</style>
